// ==============================|| OVERRIDES - LINK ||============================== //

export default function Link() {
	return {
		MuiLink: {
			root: {},
			defaultProps: {},
		},
	};
}
